import {
  aiAgentQueries,
  type AiAgentCommentRecord,
  type AiAgentCommentsPage,
} from "@circle-react/lib/queries/aiAgents";
import { flatten, uniqBy } from "lodash";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";

export type BotCommentRecord = AiAgentCommentRecord;

export const useBotCommentsInfinite = ({
  profileId,
  enabled,
  perPage = 10,
}: {
  profileId?: number;
  enabled?: boolean;
  perPage?: number;
}) => {
  const infiniteQuery = useInfiniteQuery({
    ...aiAgentQueries.comments({ profileId: profileId ?? 0, perPage }),
    enabled: Boolean(profileId) && Boolean(enabled),
    getNextPageParam: (lastPage: AiAgentCommentsPage) =>
      lastPage.has_next_page ? lastPage.page + 1 : undefined,
  });

  const comments = useMemo(
    () =>
      infiniteQuery.isInitialLoading || !infiniteQuery.data
        ? []
        : uniqBy(flatten(infiniteQuery.data.pages.map(p => p.records)), "id"),
    [infiniteQuery.data, infiniteQuery.isInitialLoading],
  );

  return {
    data: infiniteQuery.data,
    error: infiniteQuery.error,
    fetchNextPage: infiniteQuery.fetchNextPage,
    hasNextPage: infiniteQuery.hasNextPage,
    isLoading: infiniteQuery.isInitialLoading,
    comments,
  };
};
